import { render, staticRenderFns } from "./SaleInvoicesReportsTable.vue?vue&type=template&id=2d07a79c&"
import script from "./SaleInvoicesReportsTable.vue?vue&type=script&lang=js&"
export * from "./SaleInvoicesReportsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports